<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          label="Наименование"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <AddressStructuredField
          @change="v.address.$model = $event"
          :value="v.address.$model"
          :v="v.address"
          label="Адрес (место нахождения) организации"
        />
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          label="ИНН организации"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты представителя"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.phone.$model"
          :errorMessages="getValidationErrorText(v.phone)"
          v-mask="['+7 ### ###-##-##']"
          label="Контактный телефон"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';

import {
  getValidationErrorText,
  EMAIL,
  MAX_LENGTH_EMAIL,
  EMOJI,
} from '@/utils/validate';
import AddressStructuredField, {
  addressValidate,
} from '@/components/base/AddressStructuredField';

export const foreignOrganizationModel = {
  name: '',
  address: '',
  inn: '',
  email: '',
  phone: '',
};

export const foreignOrganizationValidation = {
  name: {
    required,
    maxLength: maxLength(1000),
    EMOJI,
  },
  address: {
    required,
    ...addressValidate(),
  },
  inn: {
    required,
    maxLength: maxLength(10),
    EMOJI,
  },
  email: {
    required,
    EMAIL,
    maxLength: maxLength(MAX_LENGTH_EMAIL),
  },
  phone: {
    minLength: minLength(16),
  },
};

export default {
  name: 'ForeignOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: { AddressStructuredField },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>
